<section class="tasks-container">
  <div class="tasks-heading">
    <i class="bx bx-check-circle heading-icon"></i>
    <h1>Tasks</h1>
  </div>
  <div class="tasks-nav">
    <div class="tabs">
      <button class="tab" [ngClass]="{'active': activeTab === 'tasks'}"
        (click)="setActiveTab('tasks')">
        <i class="bx bx-task"></i> Tasks
      </button>
      <!-- <button class="tab" [ngClass]="{'active': activeTab === 'assignee'}"
        (click)="setActiveTab('assignee')">
        <i class="bx bx-user"></i> Assignee
      </button>
      <button class="tab" [ngClass]="{'active': activeTab === 'priority'}"
        (click)="setActiveTab('priority')">
        <i class="bx bx-flag"></i> Priority
      </button> -->
    </div>
    <!-- <div class="filter-controls">
      <div class="selection-info" *ngIf="selectedTasks.length > 0">
        <span class="selected-count">{{ selectedTasks.length }} selected</span>
        <button type="button" class="icon-button delete-button"
          (click)="deleteSelectedTasks()"
          [disabled]="isDeleteInProgress">
          <ng-container *ngIf="!isDeleteInProgress; else deleteLoading">
            <i class="bx bx-trash" title="Delete selected"></i>
          </ng-container>
          <ng-template #deleteLoading>
            <span class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
          </ng-template>
        </button>
      </div>
      <div class="col">
        <div ngbDropdown class="d-inline-block" #dropdown="ngbDropdown">
            <button type="button" class="btn btn-outline-secondary" id="dropdownForm1" ngbDropdownToggle>
                <i class="bx bx-filter"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                <div class="p-3">
                    <div class="mb-2">
                        <label for="date-filter"><i class="bx bx-filter mr-1"></i>Date Filter</label>
                        <ng-select class="ng-filter" [clearable]="false" [searchable]="false" [(ngModel)]="selectedFilter">
                            <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                        </ng-select>
                    </div>
                    <ng-container *ngIf="selectedFilter==='Custom'">
                        <div class="mb-2">
                            <label for="date"><i class="bx bx-calendar mr-1"></i>From Date</label>
                            <input type="date" #f [(ngModel)]="fromDate" (ngModelChange)="f?.blur();" class="form-control">
                        </div>
                        <div class="mb-2">
                            <label for="date"><i class="bx bx-calendar mr-1"></i>To Date</label>
                            <input type="date" [(ngModel)]="toDate" #t (ngModelChange)="t?.blur();" class="form-control">
                        </div>
                    </ng-container>
                    <div class="mb-2">
                        <label for="project-filter"><i class="bx bx-filter mr-1"></i>Project</label>
                        <ng-select placeholder="Choose..." [(ngModel)]="projectId" class="ng-filter" [clearable]="false" [searchable]="false">
                            <ng-option *ngFor="let project of projects" [value]="project.id">
                                {{ project.name }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="mb-2">
                        <label for="status-filter"><i class="bx bx-list-check mr-1"></i>Status</label>
                        <ng-select placeholder="Select Status" [(ngModel)]="selectedStatus" class="ng-filter"
                            [clearable]="false" [searchable]="false">
                            <ng-option *ngFor="let status of statuses" [value]="status">{{ status }}</ng-option>
                        </ng-select>
                    </div>
                    <div class="mb-2">
                        <label for="priority-filter"><i class="bx bx-up-arrow-circle mr-1"></i>Priority</label>
                        <ng-select placeholder="Select Priority" [(ngModel)]="selectedPriority" class="ng-filter"
                            [clearable]="false" [searchable]="false">
                            <ng-option *ngFor="let priority of priorities" [value]="priority">{{ priority }}</ng-option>
                        </ng-select>
                    </div>
                    <button type="button" (click)="filterAndFetchMilestone(selectedFilter,dropdown);" class="btn btn-secondary w-100">
                        Search
                    </button>
                </div>
                <div class="dropdown-divider"></div>
            </div>
        </div>
    </div>
      <button class="filter-button" (click)="sortTasks('asc')"
        title="Sort Ascending"><i
          class="bx bx-up-arrow-alt"></i></button>
      <button class="filter-button" (click)="sortTasks('desc')"
        title="Sort Descending"><i
          class="bx bx-down-arrow-alt"></i></button>
      <button class="new-task-button" (click)="openSidePopup(false, null)">
        New <i class="bx bx-chevron-down"></i>
      </button>
    </div> -->
  </div>
  <div class="tasks-table">
    <div class="table-header">
      <div class="checkbox-column">
        <input type="checkbox"
          [checked]="isAllTasksSelected"
          (change)="toggleSelectAll()">
      </div>
      <div class="id-column"><i class="bx bx-hash"></i>ID</div>
      <div class="name-column"><i class="bx bx-file-blank"></i> Title</div>
      <div class="status-column"><i class="bx bx-loader-circle"></i>
        Status</div>
      <div class="assignee-column"><i class="bx bx-user-check"></i>
        Assignee</div>
      <div class="priority-column"><i class="bx bx-flag"></i> Priority</div>
      <div class="date-column" (click)="toggleDatePicker()"><i
          class="bx bx-calendar"></i> Due Date</div>
      <div class="estimated-hours-column"><i class="bx bx-task"></i> Exp
        Hrs</div>
      <div class="milestone-column"><i class="bx bx-calendar"></i>
        Milestone</div>
      <div class="attachments-column"><i class="bx bx-task"></i>
        Attachments</div>

      <!-- <div class="status-column"><i class="bx bx-task"></i>Expected Hours</div> -->
    </div>
    <div class="table-body">
      <form [formGroup]="task">
        <ng-container formArrayName="tasks"
          *ngFor="let task of tasks.controls; let i = index">
          <div class="table-row" [formGroupName]="i"
            [ngClass]="{'selected': task.id && selectedTasks.includes(task.id)}">
            <div class="checkbox-column">
              <input type="checkbox" formControlName="selected" tabindex="-1"
                [checked]="task.value.selected"
                (change)="toggleTaskSelection(task.id)" />
            </div>
            <div class="id-column">T:{{ task.value.sequence }}</div>
            <!-- Name -->
            <div class="name-column">
              <i class="bx"
                [ngClass]="{'bx-chevron-right': !task.isExpanded, 'bx-chevron-down': task.isExpanded}"
                (click)="toggleExpand(task)"></i>
              <textarea rows="1" #taskTitle (input)="resizeTextArea(taskTitle)"
                formControlName="title" placeholder="Enter task title"
                class="name-input" (blur)="upsertTask(task)"></textarea>
              <span *ngIf="!task.editTask"
                (click)="editTaskName(task)">{{ task.title }}</span>
            </div>
            <!-- Status -->
            <div class="status-column" tabindex="0"
              (keydown.enter)="toggleStatusDropdown(task.value)">
              <div class="status-dropdown">
                <div class="status-display"
                  (click)="toggleStatusDropdown(task.value)">
                  <span class="status-badge" [ngClass]="{
                  'status-not-started': task.value.status === 'NOT_STARTED'|| !task.value?.status,
                  'status-in-progress': task.value.status === 'IN_PROGRESS',
                  'status-completed': task.value.status === 'COMPLETED',
                  'status-on-hold': task.value.status === 'HOLD',
                  'status-re-assigned': task.value.status === 'REASSIGNED'
                }">
                    <i
                      [class]="'bx ' + (task.value.status === 'NOT_STARTED' ? 'bx-pause-circle' : task.value.status === 'IN_PROGRESS' ? 'bx-time' : task.value.status === 'COMPLETED' ? 'bx-check-circle' : task.value.status==='REASSIGNED'?'bx-refresh': 'bx-stop-circle')"></i>
                    {{ getTaskStatus(task.value.status) }}
                  </span>
                  <!-- <i class="bx bx-chevron-down"></i> -->
                </div>
                <div class="dropdown-menu"
                  *ngIf="task.value.showStatusDropdown">
                  <div class="dropdown-item" *ngFor="let status of statuses"
                    (click)="setStatus(task, status)">
                    <span class="status-badge"
                      [ngClass]="{'status-not-started':status === 'NOT_STARTED','status-in-progress': status === 'IN_PROGRESS','status-completed': status === 'COMPLETED','status-on-hold': status === 'HOLD' , 'status-re-assigned': status === 'REASSIGNED'}">
                      <i
                        [class]="'bx ' + (status === 'NOT_STARTED' ? 'bx-pause-circle' : status === 'IN_PROGRESS' ? 'bx-time' : status === 'COMPLETED' ? 'bx-check-circle' : status==='REASSIGNED'?'bx-refresh': 'bx-stop-circle')"></i>
                      {{getTaskStatus(status)}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Assignee -->
            <div class="assignee-column" tabindex="0"
              (keydown.enter)="toggleAssigneeDropdown(task.value,search);">
              <div class="assignee-dropdown">
                <div class="assignee-display"
                  (click)="toggleAssigneeDropdown(task.value)">
                  <div *ngIf="task?.value?.assignedToId"
                    class="selected-assignee">
                    <div class="assignee-avatar capitalize">{{
                      task?.value?.assignedToName.charAt(0)
                      }}</div>
                    {{ task?.value?.assignedToName }}
                  </div>
                  <div *ngIf="!task?.value?.assignedToName"
                    class="assignee-placeholder">Select Assignee...</div>
                  <!-- <i class="bx bx-chevron-down"></i> -->
                </div>
                <div class="dropdown-menu"
                  *ngIf="task.value.showAssigneeDropdown">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text"
                      placeholder="Type to search..."
                      (input)="searchKeyword=$event.target.value"
                      (keydown)="handleKeyDown($event,task,'assignee')">
                  </div>
                  <div class="dropdown-list">
                    <div
                      *ngIf="(employees | search : 'employeeName' : searchKeyword)?.length > 0; else noEmployeesFound">
                      <div
                        *ngFor="let employee of employees | search : 'employeeName' : searchKeyword; let a = index"
                        class="dropdown-item" [class.active]="a === searchIndex"
                        (click)="setAssignee(task, employee)">
                        <div class="assignee-avatar">{{
                          employee.employeeName.charAt(0)
                          }}</div>
                        {{ employee.employeeName }}
                      </div>
                    </div>
                    <ng-template #noEmployeesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer" (click)="setAssignee(task,null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div>
            <!-- Priority -->
            <div class="priority-column" tabindex="0"
              (keydown.enter)="togglePriorityDropdown(task.value);">
              <div class="priority-dropdown">
                <div class="priority-display"
                  (click)="togglePriorityDropdown(task.value)">
                  <span class="priority-badge" [ngClass]="{
                  'priority-low': task.value.priority === 'LOW',
                  'priority-medium': task.value.priority === 'MID',
                  'priority-high': task.value.priority === 'HIGH'}">
                    <i class="bx bxs-flag-alt"></i>
                    {{ task.value.priority }}
                  </span>
                  <!-- <i class="bx bx-chevron-down"></i> -->
                </div>
                <div class="dropdown-menu"
                  *ngIf="task.value.showPriorityDropdown">
                  <div class="dropdown-item"
                    *ngFor="let priority of priorities; let s=index;"
                    (click)="setPriority(task, priority)"
                    [class.active]="s === searchIndex">
                    <span class="priority-badge" [ngClass]="{
                      'priority-low': priority === 'LOW','priority-medium': priority === 'MID',
                      'priority-high': priority === 'HIGH'}">
                      <i class="bx bxs-flag-alt"></i>
                      {{priority}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Due Date -->
            <div class="date-column" tabindex="0"
              (click)="toggleDueDate(task.value,dueDateRef)"
              (keydown.enter)="toggleDueDate(task.value,dueDateRef);">
              <input [hidden]="!task.value.showDueDate" type="date" #dueDateRef
                (change)="upsertTask(task)"
                formControlName="deadLine"
                class="date-input">
              <span *ngIf="!task?.value?.showDueDate">{{ task.value.deadLine ?
                (task.value.deadLine |
                date:'dd MMM, yyyy') : '' }}</span>
            </div>

            <!-- Expected Hours -->
            <div class="estimated-hours-column " tabindex="0">
              <input type="number" class="form-control"
                formControlName="estimatedHours"
                (blur)="upsertTask(task)"
                placeholder />
            </div>
            <!-- Milestone -->
            <div class="milestone-column" tabindex="0"
              (keydown.enter)="toggleMilestoneDropdown(task.value,search);">
              <div class="assignee-dropdown">
                <div class="assignee-display"
                  (click)="toggleMilestoneDropdown(task.value,search);">
                  <div *ngIf="task?.value?.milestoneId"
                    class="selected-assignee">
                    {{ task?.value?.milestoneName }}
                  </div>
                  <div *ngIf="!task?.value?.milestoneName"
                    class="assignee-placeholder">Select...</div>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu"
                  *ngIf="task.value.showMilestoneDropdown">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input appAutofocus type="text"
                      placeholder="Search milestone..."
                      autofocus
                      (input)="searchKeyword=$event.target.value"
                      (keydown)="handleKeyDown($event,task,'milestone')">
                  </div>
                  <div class="dropdown-list">
                    <div
                      *ngIf="(milestones | search : 'title' : searchKeyword)?.length > 0; else noMilestonesFound">
                      <div
                        *ngFor="let milestone of milestones | search : 'title' : searchKeyword; let m = index"
                        class="dropdown-item"
                        (click)="setMilestone(task, milestone)"
                        [class.active]="m === searchIndex">
                        <div class="assignee-avatar">{{
                          milestone.title.charAt(0)
                          }}</div>
                        {{ milestone.title }}
                      </div>
                    </div>
                    <ng-template #noMilestonesFound>
                      <div class="no-results">No matches found</div>
                    </ng-template>
                  </div>
                  <div class="dropdown-footer"
                    (click)="setMilestone(task,null)">
                    <i class="bx bx-x"></i>Clear
                  </div>
                </div>
              </div>
            </div>
            <!-- Attachments -->
            <div class="attachments-column" tabindex="0">
              <div class="file-picker">
                <!-- Image container with wrapping -->
                <div class="image-grid" formArrayName="taskAttachments">
                  <ng-container
                    *ngFor="let attachment of task.get('taskAttachments').controls; let j = index">
                    <div
                      *ngIf="attachment.value.fileUrl && attachment.value.fileUrl?.length>15"
                      class="attachment-item"
                      [formGroupName]="j">
                      <div class="image-wrapper">
                        <a [href]="attachment.value.fileUrl" download
                          target="_blank">
                          <img
                            [src]="getFilePreviewIcon(attachment.value.fileUrl)"
                            alt="Uploaded Image"
                            class="uploaded-image" />
                        </a>
                      </div>
                    </div>
                  </ng-container>
                  <!-- Placeholder for new file selection -->
                  <div class="image-wrapper b-0"
                    (click)="openFilePicker(task.value,fileInput);">
                    <img
                      src="assets/images/icons/new-attachment.png"
                      alt="Add Attachment"
                      class="placeholder-image" />
                  </div>
                </div>

                <!-- Hidden File Input -->
                <input
                  type="file"
                  #fileInput
                  accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.avi,.mov,.mkv"
                  style="display: none"
                  (change)="onFileSelected($event, task.value, i)" />
              </div>
            </div>

          </div>
          <!-- <ng-container *ngIf="task.isExpanded">
          <div class="table-row sub-item"
            *ngFor="let subTask of subtasks | filterByTaskId:task.id; trackBy: trackBySubItemId"
            [ngClass]="{'selected': subTask.id && selectedTasks.includes(subTask.id)}">
            <div class="checkbox-column">
              <input type="checkbox"
                [checked]="subTask.id && selectedTasks.includes(subTask.id)"
                (change)="toggleTaskSelection(subTask.id)">
            </div>
            <div class="id-column">{{ subTask.id }}</div>
            <div class="name-column sub-item-name">
              <input *ngIf="!subTask.title || subTask.isEditing"
                [(ngModel)]="subTask.title"
                placeholder="Enter sub-task title" class="name-input"
                (blur)="saveSubTaskName(subTask)"
                (keyup.enter)="saveSubTaskName(subTask)">
              <span *ngIf="subTask.title && !subTask.isEditing"
                (click)="editSubTaskName(subTask)">{{ subTask.title
                }}</span>
            </div>
            <div class="status-column">
              <div class="status-dropdown">
                <div class="status-display"
                  (click)="toggleStatusDropdown(subTask)">
                  <span class="status-badge" [ngClass]="{
                    'status-not-started': subTask.status === 'NOT_STARTED',
                    'status-in-progress': subTask.status === 'IN_PROGRESS',
                    'status-completed': subTask.status === 'COMPLETED',
                    'status-on-hold': subTask.status === 'ON_HOLD'
                  }">
                    <i class="bx bx-pause-circle"
                      *ngIf="subTask.status === 'NOT_STARTED'"></i>
                    <i class="bx bx-time"
                      *ngIf="subTask.status === 'IN_PROGRESS'"></i>
                    <i class="bx bx-check-circle"
                      *ngIf="subTask.status === 'COMPLETED'"></i>
                    <i class="bx bx-stop-circle"
                      *ngIf="subTask.status === 'ON_HOLD'"></i>
                    {{ subTask.status || 'NOT_STARTED' }}
                  </span>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showStatusDropdown">
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'NOT_STARTED')">
                    <span class="status-badge status-not-started">
                      <i class="bx bx-pause-circle"></i> NOT_STARTED
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'IN_PROGRESS')">
                    <span class="status-badge status-in-progress">
                      <i class="bx bx-time"></i> IN_PROGRESS
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'COMPLETED')">
                    <span class="status-badge status-completed">
                      <i class="bx bx-check-circle"></i> COMPLETED
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectStatus(subTask, 'ON_HOLD')">
                    <span class="status-badge status-on-hold">
                      <i class="bx bx-stop-circle"></i> ON_HOLD
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="assignee-column">
              <div class="assignee-dropdown">
                <div class="assignee-display"
                  (click)="toggleAssigneeDropdown(subTask)">
                  <div *ngIf="subTask.assignedToName" class="selected-assignee">
                    <div class="assignee-avatar">{{
                      subTask.assignedToName.charAt(0) }}</div>
                    {{ subTask.assignedToName }}
                  </div>
                  <div *ngIf="!subTask.assignedToName"
                    class="assignee-placeholder">Select Employee</div>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showAssigneeDropdown">
                  <div class="dropdown-search">
                    <i class="bx bx-search"></i>
                    <input type="text" placeholder="Search users..."
                      (input)="filterUsers(subTask, $event)">
                  </div>
                  <div class="dropdown-list">
                    <div *ngFor="let user of users" class="dropdown-item"
                      (click)="selectAssignee(subTask, user)">
                      <div class="assignee-avatar">{{ user.avatar }}</div>
                      {{ user.name }}
                    </div>
                    <div *ngIf="users.length === 0" class="no-results">
                      No users found
                    </div>
                  </div>
                  <div class="dropdown-footer" (click)="clearAssignee(subTask)">
                    <i class="bx bx-x"></i> Clear
                  </div>
                </div>
              </div>
            </div>
            <div class="date-column">
              <input *ngIf="showDatePicker" type="date"
                [(ngModel)]="subTask.deadLine" class="date-input">
              <span *ngIf="!showDatePicker">{{ subTask.deadLine ?
                (subTask.deadLine | date:'MMMM d, yyyy') : ''
                }}</span>
            </div>
            <div class="priority-column">
              <div class="priority-dropdown">
                <div class="priority-display"
                  (click)="togglePriorityDropdown(subTask)">
                  <span class="priority-badge" [ngClass]="{
                    'priority-low': subTask.priority === 'LOW',
                    'priority-high': subTask.priority === 'HIGH'
                  }">
                    <i class="bx bx-flag"
                      *ngIf="subTask.priority === 'LOW'"></i>
                    <i class="bx bxs-flag-alt"
                      *ngIf="subTask.priority === 'HIGH'"></i>
                    {{ subTask.priority || 'LOW' }}
                  </span>
                  <i class="bx bx-chevron-down"></i>
                </div>
                <div class="dropdown-menu" *ngIf="subTask.showPriorityDropdown">
                  <div class="dropdown-item"
                    (click)="selectPriority(subTask, 'LOW')">
                    <span class="priority-badge priority-low">
                      <i class="bx bx-flag"></i> LOW
                    </span>
                  </div>
                  <div class="dropdown-item"
                    (click)="selectPriority(subTask, 'HIGH')">
                    <span class="priority-badge priority-high">
                      <i class="bx bxs-flag-alt"></i> HIGH
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container> -->
          <!-- <div class="new-sub-item sub-item" *ngIf="task.isExpanded"
          (click)="addNewTask()">
          <i class="bx bx-plus"></i> New sub-item
        </div> -->
        </ng-container>
      </form>
      <div class="new-page" (click)="addNewTask()">
        <i class="bx bx-plus"></i> New page
      </div>
    </div>
  </div>
  <div class="side-popup" [ngClass]="{'open': showSidePopup}">
    <div class="side-popup-content">
      <div class="side-popup-header">
        <h2>{{ isSubItem ? 'New Sub-Item' : 'New Task' }}</h2>
        <button class="close-button" (click)="closeSidePopup()"><i
            class="bx bx-x"></i></button>
      </div>
      <div class="side-popup-body">
        <div class="form-group">
          <label>Title</label>
          <input type="text" [(ngModel)]="newTask.title"
            placeholder="Enter task/subtask title">
        </div>
        <div class="form-group editor">
          <label>Description</label>
          <ngx-editor-menu [editor]="editor"
            [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor [editor]="editor" [(ngModel)]="newTask.desc"
            placeholder="Enter description"></ngx-editor>
        </div>
        <div class="form-group">
          <label>Status</label>
          <div class="status-dropdown">
            <div class="status-display"
              (click)="toggleStatusDropdown(newTask)">
              <span class="status-badge" [ngClass]="{
                'status-not-started': newTask.status === 'NOT_STARTED',
                'status-in-progress': newTask.status === 'IN_PROGRESS',
                'status-completed': newTask.status === 'COMPLETED',
                'status-on-hold': newTask.status === 'ON_HOLD'
              }">
                <i class="bx bx-circle"
                  *ngIf="newTask.status === 'NOT_STARTED'"></i>
                <i class="bx bx-time"
                  *ngIf="newTask.status === 'IN_PROGRESS'"></i>
                <i class="bx bx-check"
                  *ngIf="newTask.status === 'COMPLETED'"></i>
                <i class="bx bx-pause"
                  *ngIf="newTask.status === 'ON_HOLD'"></i>
                {{ newTask.status || 'NOT_STARTED' }}
              </span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="dropdown-menu" *ngIf="newTask.showStatusDropdown">
              <div class="dropdown-item"
                (click)="selectStatus(newTask, 'NOT_STARTED')">
                <span class="status-badge status-not-started">
                  <i class="bx bx-circle"></i> NOT_STARTED
                </span>
              </div>
              <div class="dropdown-item"
                (click)="selectStatus(newTask, 'IN_PROGRESS')">
                <span class="status-badge status-in-progress">
                  <i class="bx bx-time"></i> IN_PROGRESS
                </span>
              </div>
              <div class="dropdown-item"
                (click)="selectStatus(newTask, 'COMPLETED')">
                <span class="status-badge status-completed">
                  <i class="bx bx-check"></i> COMPLETED
                </span>
              </div>
              <div class="dropdown-item"
                (click)="selectStatus(newTask, 'ON_HOLD')">
                <span class="status-badge status-on-hold">
                  <i class="bx bx-pause"></i> ON_HOLD
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form-group">
          <label>Assigned To</label>
          <ng-select placeholder="Choose..." [(ngModel)]="newTask.assignedToId"
            class="ng-filter" [clearable]="true"
            [searchable]="true">
            <ng-option *ngFor="let employee of employees"
              [value]="employee.employeeId">
              {{ employee.employeeName }}
            </ng-option>
          </ng-select>
        </div> -->
        <div class="form-group">
          <label>Deadline</label>
          <input type="date" [(ngModel)]="newTask.deadLine">
        </div>
        <div class="form-group">
          <label>Estimated Time</label>
          <input type="text" [(ngModel)]="newTask.estimatedTime"
            placeholder="e.g., 2h">
        </div>
        <div class="form-group">
          <label>Completed Time</label>
          <input type="text" [(ngModel)]="newTask.completedTime"
            placeholder="e.g., 1.5h">
        </div>
        <div class="form-group" *ngIf="!isSubItem">
          <label>Project</label>
          <ng-select placeholder="Choose..." [(ngModel)]="newTask.projectId"
            class="ng-filter" [clearable]="true"
            [searchable]="true">
            <ng-option *ngFor="let project of projects" [value]="project.id">
              {{ project.name }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group" *ngIf="!isSubItem">
          <label>Milestone</label>
          <ng-select placeholder="Choose..." [(ngModel)]="newTask.milestoneId"
            class="ng-filter" [clearable]="true"
            [searchable]="true">
            <ng-option *ngFor="let milestone of milestones"
              [value]="milestone.id">
              {{ milestone.title }}
            </ng-option>
          </ng-select>
        </div>
        <div class="form-group" *ngIf="isSubItem">
          <label>Parent Task</label>
          <input type="text"
            [value]="parentTaskId ? 'Task #' + parentTaskId : ''" readonly>
        </div>
        <div class="form-group">
          <label>Priority</label>
          <div class="priority-dropdown">
            <div class="priority-display"
              (click)="togglePriorityDropdown(newTask)">
              <span class="priority-badge" [ngClass]="{
                'priority-low': newTask.priority === 'LOW',
                'priority-medium': newTask.priority === 'MEDIUM',
                'priority-high': newTask.priority === 'HIGH'
              }">
                <i class="bx bx-flag" *ngIf="newTask.priority === 'LOW'"></i>
                <i class="bx bx-flag-check"
                  *ngIf="newTask.priority === 'MEDIUM'"></i>
                <i class="bx bxs-flag-alt"
                  *ngIf="newTask.priority === 'HIGH'"></i>
                {{ newTask.priority || 'LOW' }}
              </span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="dropdown-menu" *ngIf="newTask.showPriorityDropdown">
              <div class="dropdown-item"
                (click)="selectPriority(newTask, 'LOW')">
                <span class="priority-badge priority-low">
                  <i class="bx bx-flag"></i> LOW
                </span>
              </div>
              <div class="dropdown-item"
                (click)="selectPriority(newTask, 'MEDIUM')">
                <span class="priority-badge priority-medium">
                  <i class="bx bx-flag-check"></i> MEDIUM
                </span>
              </div>
              <div class="dropdown-item"
                (click)="selectPriority(newTask, 'HIGH')">
                <span class="priority-badge priority-high">
                  <i class="bx bxs-flag-alt"></i> HIGH
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="taskDisabled">Disabled</label>
          <input id="taskDisabled" type="checkbox"
            [(ngModel)]="newTask.disabled">
        </div>
      </div>
      <div class="side-popup-footer">
        <button class="save-button" (click)="saveNewTask()">Save</button>
        <button class="cancel-button"
          (click)="closeSidePopup()">Cancel</button>
      </div>
    </div>
  </div>
</section>